import { Clippy, addToGlobalThisRet } from "@plugins";

function initFilesAttacher() {
    const attachers = document.querySelectorAll(".js-file-input-attacher-init");

    if (attachers && attachers.length > 0) {
        for (const attacher of attachers) {
            if (!attacher.classList.contains("attacher-initiallized")) {
                new Clippy(attacher, {
                    multi: false,
                    input: {
                        el: ".js-file-input",
                    },
                    filesList: {
                        classes: ["file-input__list"],
                        items: {
                            template(file) {
                                return `
                                    <div class="file-input__item">
                                        <span class="file-input__item-name">${file.name}.${file.extension}</span>
                                        <button class="file-input__item-remove-btn" data-clippy-remover></button>
                                    </div>
                                `;
                            },
                        },
                        insert: {
                            functionType: "append",
                        },
                    },
                });

                attacher.classList.add("attacher-initiallized");
            }
        }
    }
}

window.addEventListener("load", initFilesAttacher());

addToGlobalThisRet(initFilesAttacher, "initFilesAttacher");
